import { FACADE_COLORS } from "../catalog";
import type {
  FacadeColorType,
  FacadeType,
  ShelvingCellConfig,
  WardrobeModule
} from "../types";

type FacadePaintSettings = Pick<
  WardrobeModule | ShelvingCellConfig,
  "facadeColor" | "facadeColorHex" | "facadeColorCode"
>;

const HEX_COLOR = /^#[0-9a-f]{6}$/i;

export const facadeSupportsMilling = (facade: FacadeType) =>
  facade === "satin" || facade === "gloss";

/**
 * Ширина алюминиевой рамки стеклянного фасада: только широкий профиль 50 мм,
 * потому что петли обычные (решение Сергея 28.09).
 */
export const GLASS_FRAME_WIDTH_MM = 50;

/** Рамка на узкой створке не съедает больше пятой части стекла. */
export const glassFrameWidthMm = (widthMm: number, heightMm: number) =>
  Math.min(GLASS_FRAME_WIDTH_MM, widthMm * 0.2, heightMm * 0.2);

export const normalizeFacadeColorHex = (value: unknown) => {
  const text = String(value ?? "").trim();
  return HEX_COLOR.test(text) ? text.toUpperCase() : undefined;
};

export const normalizeFacadeColorCode = (value: unknown) => {
  const text = String(value ?? "")
    .trim()
    .replace(/\s+/g, " ")
    .slice(0, 32);
  return text || undefined;
};

export const facadePaintHex = (settings: FacadePaintSettings) =>
  normalizeFacadeColorHex(settings.facadeColorHex) ??
  FACADE_COLORS[(settings.facadeColor ?? "white") as FacadeColorType].color;

export const facadePaintLabel = (settings: FacadePaintSettings) => {
  const preset = FACADE_COLORS[settings.facadeColor ?? "white"];
  const customHex = normalizeFacadeColorHex(settings.facadeColorHex);
  const code = normalizeFacadeColorCode(settings.facadeColorCode);
  // Без «экранного образца» (Сергей, 28.10): код NCS или цвет, выбранный в палитре.
  if (code) return code;
  if (customHex && customHex !== preset.color.toUpperCase()) {
    return `цвет по палитре ${customHex}`;
  }
  return preset.name;
};

type FacadePaintSidesSettings = { facade?: FacadeType; facadePaintSides?: "two" };

export const facadePaintedOnBothSides = (settings: FacadePaintSidesSettings) =>
  facadeSupportsMilling(settings.facade ?? "wood") && settings.facadePaintSides === "two";


/** Цвет эмали и стороны покраски — для сметы и техкарты. */
export const facadePaintDescription = (settings: FacadePaintSettings & FacadePaintSidesSettings) =>
  `${facadePaintLabel(settings)}, покраска с ${facadePaintedOnBothSides(settings) ? "двух сторон" : "одной стороны"}`;
